import { getDefaultHeight } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const OpenBookIcon: React.FC<Props> = ({
  color = "currentColor",
  ...svgProps
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 30 32"
      height={getDefaultHeight(svgProps, 32)}
      {...svgProps}
      fill={color}
    >
      <path d="M29.533 2.292c-0.163-0.105-0.361-0.116-0.524-0.035l-14.115 6.516-14.115-6.516c-0.175-0.081-0.372-0.070-0.524 0.035-0.163 0.105-0.256 0.279-0.256 0.465v21.516c0 0.209 0.116 0.396 0.303 0.489l14.348 7.168c0 0 0.012 0 0.012 0 0.070 0.035 0.151 0.058 0.233 0.058s0.163-0.023 0.233-0.058c0 0 0.012 0 0.012 0l14.348-7.168c0.186-0.093 0.303-0.279 0.303-0.489v-21.516c0-0.186-0.093-0.361-0.256-0.465zM1.105 3.619l13.242 6.109v20.817l-13.242-6.609v-20.317zM28.684 23.936l-13.242 6.621v-20.829l13.242-6.109v20.317z"></path>
      <path d="M3.619 1.047l11.031 5.516c0.081 0.035 0.163 0.058 0.244 0.058s0.175-0.023 0.244-0.058l11.031-5.516c0.268-0.14 0.384-0.465 0.244-0.745-0.14-0.268-0.465-0.384-0.745-0.244l-10.775 5.399-10.787-5.399c-0.268-0.14-0.605-0.023-0.745 0.244-0.128 0.279-0.023 0.605 0.256 0.745z"></path>
    </svg>
  );
};
